import React, { useState, useContext } from 'react';
// import {Link, NavLink, useLocation} from 'react-router-dom';
// import useMediaQuery from '@material-ui/core/useMediaQuery';

import {WebContext} from '../../../Utility';
import compnentsMap from './components';



export default ({type = 'NAVBAR_SEARCH_1', nonTransparentNav = false}) => {
  // const [bgImg, setBgImg] = useState('http://app.travclan.com/media/appcms/navbar_bg.jpg');
  const {username = null} = useContext(WebContext) || {};

  // const commonClasses = useCommonStyles();
  // const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  const [componentType, setComponentType] = useState(type);
  // const [componentImg, setComponentImg] = useState(null);

  const ComponentName = componentType ? compnentsMap[componentType] : null;

  if(!ComponentName) return null
    return (<ComponentName nonTransparentNav={nonTransparentNav}
      username={username}
    />
  )

}
